import React from 'react';
import { Icon } from './Icon.js';
export const IconBluetooth = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M6 7L18 17L12 21V3L18 7L6 17", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconBluetooth.js.map